var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card p-2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{class:[
        'item-status__icon  btn btn-sm w-100',
        _vm.highlight_changed == 1
          ? 'btn-outline--warning'
          : 'btn-outline--danger',
      ],attrs:{"role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.handleMakeHighlight()}}},[_c('i',{class:[
          'fas',
          _vm.highlight_changed == 1 ? 'fa-check-circle' : 'fa-cross-circle',
        ]}),_vm._v("\n      "+_vm._s(_vm.highlight_changed == 1 ? 'Free' : 'Paid')+"\n    ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h6',{staticClass:"card-title"},[_vm._v("Video Highlight")])])
}]

export { render, staticRenderFns }